import { useDebugValue, useEffect, useMemo } from "react";

export function useTimeoutEffect(fn, ms) {
  const castAt = useMemo(() => new Date(Date.now() + ms), [ms])

  useEffect(() => {
    const timeout = setTimeout(() => fn(), ms)

    return () => {
      clearTimeout(timeout)
    }
  }, [fn, ms])

  useDebugValue(`timeout scheduled for ${castAt}`)
}
